import React from 'react';
import './detailContact.scss'
import FormGroup from '../Form-Group';
const DetailContact = () => {
    return (
        <div className="detail-contact-molecules">
            <div className="row">
                <div className="col-lg-12">
                    <form>
                        <div className="row">
                            <div className="col-6 col-sm-6 col-md-6">
                                <FormGroup element={"input"} label={""} placeholder={"Your Name *"} type={"text"}/>
                                <FormGroup element={"input"} label={""} placeholder={"Your Email *"} type={"email"}/>
                                <FormGroup element={"input"} label={""} placeholder={"Your Phone"} type="tel"/>                        
                            </div>
                            <div className="col-6 col-sm-6 col-md-6">
                                <FormGroup element={"input"} label={""} placeholder={"Your Password"} type={"password"}/>
                                <FormGroup element={"textarea"}label={""} placeholder={"Your Message *"}/>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 text-center">
                                <button className="btn btn-primary btn-xl text-uppercase" type="submit">Send Message</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default DetailContact;